import Swiper from 'swiper';
import { Navigation, A11y, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/a11y';
import './ContentImageSliderStyle2.css';

function contentImageSliderStyle2() {
    const sliders = document.querySelectorAll('[data-content-image-slider-styletwo]');

    // Loop to all existing elements
    sliders.forEach((slider) => {
        const sliderContainer = slider.querySelector('.swiper');

        if(sliderContainer instanceof HTMLElement) {
            new Swiper(sliderContainer, {
                // Install modules
                modules: [Navigation, A11y, Pagination, Autoplay],
                slidesPerView: 2,
                centeredSlides: true,
                spaceBetween: 30,
                initialSlide: 1,
                navigation: {
                    nextEl: '.content-image-slider-style2__control-next',
                    prevEl: '.content-image-slider-style2__control-prev',
                },
                autoplay: {
                    delay: 5000,
                    pauseOnMouseEnter: true
                },
                pagination: {
                    el: ".content-image-slider-style2__pagination"
                },
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 1280px
                    1280: {
                        spaceBetween: 150,
                    },
                    // when window width is >= 1024px
                    1024: {
                        spaceBetween: 100,
                    },
                    // when window width is >= 768px
                    768: {
                        spaceBetween: 70,
                    },
                    // when window width is >= 640px
                    640: {
                        spaceBetween: 50,
                    },
                }
            });
        }
    })
}

export default contentImageSliderStyle2;

